import React, { PureComponent } from "react";
import Link from "next/link";

import ProfilePic from "../profile-pic/profile-pic";
import VoteButtons from "../vote-buttons/vote-buttons";
import Heading from "../heading/heading";
import Tag from "../tag/tag";
import ReportUserButton from "../report-user-button/report-user-button";
import MiniMenu from "../mini-menu/mini-menu";

import "./community-question.scss";

class CommunityQuestion extends PureComponent {
  render() {
    const {
      poster,
      title,
      type,
      tags,
      ratedUpKnowledgeItems,
      ratedDownKnowledgeItems,
      id,
      slug,
      answers,
      myId,
      referencePageNumber,
      toggleOverlay,
    } = this.props;

    return (
      <article className="comm-quest">
        <div className="comm-quest__inner">
          <div className="comm-quest__rating">
            <VoteButtons
              ratedUpKnowledgeItems={ratedUpKnowledgeItems}
              ratedDownKnowledgeItems={ratedDownKnowledgeItems}
              myId={myId}
              voteOnWhat="QUESTION"
              referenceId={id}
              posterId={poster.id}
              toggleOverlay={toggleOverlay}
              refetchQueryName="COMMUNITY_QUESTIONS_QUERY"
              refetchQueryVariables={{
                referencePageNumber,
              }}
              disabled={myId === poster.id}
            />
          </div>
          <div className="comm-quest__details">
            <div className="comm-quest__type-and-poster">
              <MiniMenu modifierClass={"comm-quest__options"} minWidth="155px">
                <ReportUserButton
                  copy="Report this question"
                  userId={poster.id}
                  reportedFrom="QUESTION"
                  relevantItemId={id}
                />
              </MiniMenu>
              <div className="comm-quest__type">{type.label}</div>
              <div className="comm-quest__asked-by">asked by</div>
              <div className="comm-quest__poster-details">
                <Link href="/profile/[id]" as={`/profile/${poster.id}`}>
                  <a>
                    <div className="comm-quest__poster-details__firstname">
                      <strong>{poster.firstName}</strong>
                    </div>
                    <ProfilePic
                      profilePic={poster.profilePic}
                      width={16}
                      height={16}
                    />
                  </a>
                </Link>
              </div>
              <div className="comm-quest__num-answers">
                (
                {`${answers.length} ${answers.length === 1 ? "answer" : "answers"
                  }`}
                )
              </div>
            </div>
            <div className="comm-quest__title">
              <Link
                href={`/the-nest/q/[slug]${process.browser ? "?pageidxref=" + referencePageNumber : ""
                  }`}
                as={`/the-nest/q/${slug}${process.browser ? "?pageidxref=" + referencePageNumber : ""
                  }`}
              >
                <a>
                  <Heading element="h2" copy={title} noUnderline />
                </a>
              </Link>
            </div>
            {tags.length > 0 && (
              <div className="comm-quest__tags">
                {tags.map((tag) => (
                  <Tag key={tag.id}
                    label={tag.label}
                    title={tag.label}
                    hasHashTag />
                ))}
              </div>
            )}
          </div>
        </div>
      </article>
    );
  }
}

export default CommunityQuestion;
